export default __webpack_public_path__ + "static/hackathon-4506f0bf395aad853aaa0addfda338f7.jpg";